export function itineraryModels() {
    $(document).on('click', '.calendar-date-text', function() {
        const selected_date = $(this).data('date');
        const source_url = $(this).data('source');
        const popup_modal = $('#ajax_modal')
        popup_modal[0].M_Modal.open();
        $.get( source_url, {selected_date:selected_date}, function( data ) {
            $( ".modal-content" ).html(data);
        });
    });

    $(document).on('click', '.itinerary_event', function() {
        const source_url = $(this).data('source');
        const popup_modal = $('#ajax_modal')
        popup_modal[0].M_Modal.open();
        $.get( source_url, function( data ) {
            $( ".modal-content" ).html(data);
        });
    });
}